<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

import AddOnLabel from '../AddOnLabel.vue';

const props = defineProps({
    title: String,
    videos: Array,
    id: String,
    addOnLabel: Boolean,
});

const moduleActive = computed(() => usePage().props.template_options.modules.youtube_component_active);
</script>

<template>
    <div :class="{ 'bg-black/10 rounded relative  ': addOnLabel }" v-if="moduleActive">
        <AddOnLabel v-if="addOnLabel" />

        <div class="container relative py-12 md:py-16">
            <h2 class="" v-html="title" v-if="title"></h2>

            <div class="flex items-center justify-center gap-8" v-if="videos">
                <iframe v-for="(video, i) in videos" :key="i" :src="`https://www.youtube.com/embed/${video.id}`"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen class="max-w-[50%] rounded-xl drop-shadow-md aspect-video"></iframe>
            </div>
        </div>
    </div>
</template>
